/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useContext, useState } from 'react';

import { getNoticeTypologiesAndCriterias } from '../../../../../../api/theHive/criteriaGroups';
import { TypologyAndCriteriaData } from '../../../../../../api/theHive/criteriaGroups/types';
import { GlobalContext } from '../../../../../../context/global';
import useErrorMessage from '../../../../../../hooks/useErrorMessage';

export interface UseTypologyGroupsReturn {
  criteriasGroup: TypologyAndCriteriaData[];
  fetchTypologyGroups: () => Promise<void>;
  isLoading: boolean;
}

export function useTypologyGroups(noticeId?: number): UseTypologyGroupsReturn {
  const [criteriasGroup, setCriteriasGroup] = useState<
    TypologyAndCriteriaData[]
  >([]);
  const [isLoading, setIsLoading] = useState(false);

  const { setOpenSnackbar, setErrorMessage, setSnackbarMessage } =
    useContext(GlobalContext);
  const { getErrorMessage } = useErrorMessage();

  const fetchTypologyGroups = useCallback(async () => {
    if (!noticeId) return;

    setIsLoading(true);
    try {
      const response = await getNoticeTypologiesAndCriterias(noticeId);

      setErrorMessage(false);
      setCriteriasGroup(response.data);
    } catch (error) {
      setSnackbarMessage(getErrorMessage(error));
      setErrorMessage(true);
      setOpenSnackbar(true);
    } finally {
      setIsLoading(false);
    }
  }, [noticeId]);

  return {
    criteriasGroup,
    isLoading,
    fetchTypologyGroups,
  };
}
